// A resource's button, wherever it shows (Resources, a week's worksheet and prompts), with the
// boards' words before and after: Download then Downloaded, Copy prompt then Copied, Open then
// Opened in a new tab (FEHome.dc.html, FEWeek.dc.html, PhoneWeek.dc.html, POYT.dc.html). A refusal,
// a link that can't be copied, or staff viewing as a member, shows its line under the button.
// resourceAction.js says what each kind does.
import { vimeoSrc, parseVimeo } from '../free/vimeo.js'
import { readOnlyControl, VIEWING_AS_LINE } from '../lib/viewAs.jsx'
import { useResourceAction } from './resourceAction.js'

export function ResourceButton({ card, className = 'pp-res-btn', icon = null, short = false, onVideo }) {
  const act = useResourceAction(card)
  if (!card.action) return null
  const done = act.status === 'done'
  let label = done ? card.action.doneLabel : card.action.label
  // PhoneWeek.dc.html's prompts say Copy, not Copy prompt
  if (short && card.action.kind === 'copy') label = done ? 'Copied' : 'Copy'
  const cls = `${className}${done ? ` ${className}--done` : ''}`
  const line = act.line ? <span className="pp-res-line" role="alert">{act.line}</span> : null
  // a file or a tool while staff view as a member: off, with the line saying why (as Free resources)
  if (act.blocked) {
    return (
      <span className="pp-res-act">
        <button type="button" className={cls} {...readOnlyControl(true)}>{icon}{label}</button>
        <span className="pp-res-line">{VIEWING_AS_LINE}</span>
      </span>
    )
  }

  // a tool: its page in the hub, in a new tab, where the tool runner runs it (ToolPage.jsx)
  if (card.action.kind === 'tool' && card.href) {
    return (
      <span className="pp-res-act">
        <a className={cls} href={card.href} target="_blank" rel="noopener" onClick={act.run}>{icon}{label}</a>
        {line}
      </span>
    )
  }
  if (card.action.kind === 'link' && card.url && !card.url.startsWith('/')) {
    return (
      <span className="pp-res-act">
        <a className={cls} href={card.url} target="_blank" rel="noopener noreferrer" onClick={act.run}>{icon}{label}</a>
        {line}
      </span>
    )
  }
  function click(e) {
    act.run(e)
    if (card.action.kind === 'video') onVideo?.()
  }
  return (
    <span className="pp-res-act">
      <button type="button" className={cls} onClick={click} aria-busy={act.status === 'busy' || undefined}>
        {icon}{label}
      </button>
      {line}
    </span>
  )
}

// A video resource, playing on the page in Vimeo's player (no board draws 1: undrawn, listed)
export function VideoPanel({ card, onClose }) {
  const v = parseVimeo(card.vimeo)
  return (
    <div className="pp-res-video">
      {v
        ? <div className="pp-player pp-player--on"><iframe src={vimeoSrc(v, { autoplay: true })} title={card.title} allow="autoplay; fullscreen; picture-in-picture; encrypted-media" allowFullScreen /></div>
        : <p className="pp-res-line">This video isn't ready to play yet.</p>}
      <button type="button" className="pp-res-close" onClick={onClose}>Close the video</button>
    </div>
  )
}
